const baseFromEnv = process.env.REACT_APP_SITE_URL || 'https://dynalogindia.com';

export const BASE_URL = baseFromEnv.replace(/\/$/, '');
export const SITE_NAME = 'Dynalog India';
export const DEFAULT_SOCIAL_IMAGE = `${BASE_URL}/logo512.png`;

export const defaultSEO = {
  title: `${SITE_NAME} | Premium Online Shopping Experience`,
  description:
    'Discover curated gadgets, fashion, and lifestyle essentials with fast shipping, secure checkout, and premium support on Dynalog India.',
  keywords:
    'Dynalog India, premium ecommerce, buy gadgets online, lifestyle store, fashion deals, electronics sale, online shopping India',
  author: `${SITE_NAME} Team`,
  robots: 'index, follow',
  image: DEFAULT_SOCIAL_IMAGE,
  type: 'website',
  locale: 'en_US',
};

export const defaultOpenGraph = {
  site_name: SITE_NAME,
  type: 'website',
  image_alt: `${SITE_NAME} featured collection`,
};

export const defaultTwitter = {
  card: 'summary_large_image',
  site: '@DynalogIndia',
  creator: '@DynalogIndia',
};

export const socialProfiles = [
  'https://www.facebook.com/DynalogIndia',
  'https://www.instagram.com/DynalogIndia',
  'https://www.linkedin.com/company/DynalogIndia',
  'https://twitter.com/DynalogIndia',
];

export const buildCanonicalUrl = (path = '') => {
  if (!path) return `${BASE_URL}/`;
  if (/^https?:\/\//i.test(path)) return path;
  // Split off the query string before adding the trailing slash — react-snap
  // prerenders every route to a real directory + index.html on disk, so Apache
  // 301-redirects the no-slash version to add the slash. Canonical/og:url need
  // to point straight at that final URL instead of the one that gets redirected.
  const [pathname, query = ''] = path.split('?');
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const withTrailingSlash = normalizedPath.endsWith('/') ? normalizedPath : `${normalizedPath}/`;
  return `${BASE_URL}${withTrailingSlash}${query ? `?${query}` : ''}`;
};

export const toAbsoluteUrl = (value) => {
  if (!value) return undefined;
  if (/^https?:\/\//i.test(value)) return value;
  const normalizedValue = value.startsWith('/') ? value : `/${value}`;
  return `${BASE_URL}${normalizedValue}`;
};

